module.exports = __webpack_public_path__ + "code-reuse.1UHDpJkC.svg";